module.exports = __webpack_public_path__ + "img/delete-enabled.be1e4292.svg";